import { action } from 'satcheljs/lib/legacy';
import acceptSharedCalendarInvite from '../services/acceptSharedCalendarInvite';
import selectNewCalendar from '../services/selectNewCalendar';
import ItemId from 'owa-service/lib/contract/ItemId';

const acceptInvite = action('acceptInvite')(function acceptInvite(
    sharingInviteItemId: ItemId
): Promise<boolean> {
    return acceptSharedCalendarInvite(sharingInviteItemId)
        .then(response => {
            if (response.ResponseClass == 'Success' && response.NewCalendarEntryId) {
                // select the new calendar
                selectNewCalendar(response.NewCalendarEntryId.Id);
            }

            return new Promise<boolean>(resolve => {
                resolve(response.ResponseClass == 'Success');
            });
        })
        .catch(() => Promise.reject('[acceptSharedCalendarInvite] failed'));
});

export default acceptInvite;
